// ── helpers ───────────────────────────────────────────────────────────────────
function weekMondayISO(weeksBack, dayOff = 0) {
  const now = new Date();
  const dow = now.getDay();
  const toMon = dow === 0 ? -6 : 1 - dow;
  const d = new Date(now);
  d.setDate(d.getDate() + toMon - weeksBack * 7 + (dayOff % 5));
  d.setHours(9 + (dayOff % 3), 0, 0, 0);
  return d.toISOString();
}

let _n = 5000;
function gen(co, status, weeksBack, dayOff = 0, extra = {}) {
  const id = `demo_${_n++}`;
  return {
    id,
    empfaenger_unternehmen: co,
    erstellt_am: weekMondayISO(weeksBack, dayOff),
    bewerbungs_status: status,
    quelle: _n % 5 === 0 ? 'extern' : 'cvflow',
    ...extra,
  };
}

// ── 15 Demo-Stellen ───────────────────────────────────────────────────────────
export const DEMO_STELLEN = [
  gen('Deloitte',       'kennenlerngespraech', 1, 2, {
    empfaenger_ansprechperson: 'Mara Hofer',
    abschick_datum: '2026-04-15',
    gehaltsvorstellung: '67.000 €',
    interview_datum: '2026-05-04',
    interview_uhrzeit: '10:00',
  }),
  gen('Dataport',       'zusage', 1, 3, {
    empfaenger_ansprechperson: 'Tim Albrecht',
    abschick_datum: '2026-04-15',
    gehaltsvorstellung: '75.000 €',
    interview_datum: '2026-05-11',
    interview_uhrzeit: '11:00',
  }),
  gen('SAP',            'abgeschickt', 2, 1, {
    empfaenger_ansprechperson: 'Herr Schmidt',
    abschick_datum: '2026-04-14',
    gehaltsvorstellung: '72.000 €',
    interview_datum: '2026-05-19',
    interview_uhrzeit: '10:00',
  }),
  gen('Personio',       'abgeschickt', 2, 2, {
    abschick_datum: '2026-04-13',
    gehaltsvorstellung: '65.000 €',
  }),
  gen('Celonis',        'kennenlerngespraech', 2, 3, {
    empfaenger_ansprechperson: 'Lara Voss',
    abschick_datum: '2026-04-10',
    gehaltsvorstellung: '70.000 €',
    interview_datum: '2026-05-06',
    interview_uhrzeit: '09:30',
  }),
  gen('N26',            'absage', 2, 4, {
    empfaenger_ansprechperson: 'Anna Beck',
    abschick_datum: '2026-04-09',
    gehaltsvorstellung: '78.000 €',
    interview_datum: '2026-05-22',
    interview_uhrzeit: '13:30',
  }),
  gen('Trade Republic', 'abgeschickt', 3, 0, {
    abschick_datum: '2026-04-08',
    gehaltsvorstellung: '80.000 €',
  }),
  gen('About You',      'zusage', 3, 1, {
    empfaenger_ansprechperson: 'Niko Kühn',
    abschick_datum: '2026-04-07',
    gehaltsvorstellung: '62.000 €',
    interview_datum: '2026-05-13',
    interview_uhrzeit: '15:00',
  }),
  gen('Zalando',        'kennenlerngespraech', 3, 2, {
    empfaenger_ansprechperson: 'Mira Sauer',
    abschick_datum: '2026-04-05',
    gehaltsvorstellung: '74.000 €',
    interview_datum: '2026-05-06',
    interview_uhrzeit: '14:00',
  }),
  gen('Delivery Hero',  'abgeschickt', 4, 1, {
    abschick_datum: '2026-04-04',
    gehaltsvorstellung: '68.000 €',
  }),
  gen('IONOS',          'absage', 4, 2, {
    empfaenger_ansprechperson: 'Jonas Lehr',
    abschick_datum: '2026-04-03',
    gehaltsvorstellung: '60.000 €',
  }),
  gen('Google',         'absage', 4, 3, {
    abschick_datum: '2026-04-12',
    gehaltsvorstellung: '85.000 €',
  }),
  gen('Volkswagen',     'unterlagen_angefertigt', 4, 4, {
    abschick_datum: '2026-04-01',
    gehaltsvorstellung: '69.000 €',
  }),
  gen('Siemens AG',     'abgeschickt', 5, 0, {
    abschick_datum: '2026-03-28',
    gehaltsvorstellung: '71.000 €',
  }),
  gen('Klarna',         'kennenlerngespraech', 5, 2, {
    empfaenger_ansprechperson: 'Julia Maier',
    abschick_datum: '2026-03-25',
    gehaltsvorstellung: '76.000 €',
  }),
];

// ── Sources ───────────────────────────────────────────────────────────────────
export const DEMO_SOURCES = [
  { name: 'LinkedIn',   value: 22 },
  { name: 'Indeed',     value: 18 },
  { name: 'StepStone',  value: 11 },
  { name: 'XING',       value:  9 },
  { name: 'Empfehlung', value:  6 },
];

// ── Todos ─────────────────────────────────────────────────────────────────────
export const DEMO_TODOS = [
  { id: 'dt1', title: 'Anschreiben für Volkswagen finalisieren', due: 'Heute',   pri: 'urgent', done: false },
  { id: 'dt2', title: 'Portfolio-PDF aktualisieren',             due: 'Heute',   pri: 'amber',  done: false },
  { id: 'dt3', title: 'Follow-up Email an Google senden',        due: 'Morgen',  pri: 'normal', done: false },
  { id: 'dt4', title: 'Vorbereitung Tech-Interview Celonis',     due: '06. Mai', pri: 'amber',  done: false },
  { id: 'dt5', title: 'Referenzen von Frau Berger anfragen',     due: '08. Mai', pri: 'normal', done: true  },
  { id: 'dt6', title: 'Gehaltsverhandlung Dataport vorbereiten', due: '11. Mai', pri: 'urgent', done: false },
];
